import type { Person } from '@domain/person';
import type { FunctionComponent } from 'react';
import {
  EuiBadge,
  EuiButtonIcon,
  EuiCopy,
  EuiDescriptionList,
  EuiFlexGroup,
  EuiFlexItem,
  EuiSpacer,
  EuiTitle,
} from '@elastic/eui';
import { formatId } from '@lib/utils';

interface IntroProps {
  person: Person;
}

const Intro: FunctionComponent<IntroProps> = ({ person }) => {
  const { idnumber, darn, firstname, surname, position, flags } = person;

  const formattedId = formatId(idnumber);

  const descriptionItems = [
    {
      title: 'ID Number',
      description: (
        <EuiFlexGroup gutterSize="xs" alignItems="center" responsive={false}>
          <EuiFlexItem grow={false}>{formattedId}</EuiFlexItem>
          <EuiFlexItem grow={false}>
            <EuiCopy textToCopy={idnumber.replace(/\s/g, '')}>
              {copy => (
                <EuiButtonIcon
                  aria-label="Copy ID number"
                  iconType="copy"
                  size="xs"
                  onClick={copy}
                />
              )}
            </EuiCopy>
          </EuiFlexItem>
        </EuiFlexGroup>
      ),
    },
    {
      title: 'DARN',
      description: (
        <EuiFlexGroup gutterSize="xs" alignItems="center" responsive={false}>
          <EuiFlexItem grow={false}>{darn}</EuiFlexItem>
          <EuiFlexItem grow={false}>
            <EuiCopy textToCopy={`${darn}`}>
              {copy => (
                <EuiButtonIcon
                  aria-label="Copy DARN"
                  iconType="copy"
                  size="xs"
                  onClick={copy}
                />
              )}
            </EuiCopy>
          </EuiFlexItem>
        </EuiFlexGroup>
      ),
    },
    { title: 'Position', description: position ?? '' },
  ];

  return (
    <>
      <EuiFlexGroup gutterSize="xs" alignItems="center" responsive={false}>
        <EuiFlexItem grow={false}>
          <EuiTitle>
            <h2>
              {firstname} {surname}
            </h2>
          </EuiTitle>
        </EuiFlexItem>
        <EuiFlexItem grow={false}>
          <EuiCopy textToCopy={`${firstname} ${surname}`}>
            {copy => (
              <EuiButtonIcon
                aria-label="Copy name"
                iconType="copy"
                size="xs"
                onClick={copy}
              />
            )}
          </EuiCopy>
        </EuiFlexItem>
      </EuiFlexGroup>
      <EuiSpacer size="s" />
      <EuiDescriptionList
        type="column"
        columnGutterSize="m"
        listItems={descriptionItems}
      />
      <EuiSpacer size="s" />
      <EuiFlexGroup direction="row" gutterSize="none" responsive={false}>
        {flags.map(flag => (
          <EuiBadge key={flag} color="#225393">
            {flag}
          </EuiBadge>
        ))}
      </EuiFlexGroup>
    </>
  );
};

export default Intro;
